
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/[appName]/[appId]",
      function () {
        return require("private-next-pages/app/[appName]/[appId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/[appName]/[appId]"])
      });
    }
  